import vue from 'vue';

import toastComponent from './main.vue';
const ToastConstructor = vue.extend(toastComponent);
const iconMap = {
  none: 'weui-icon-none', // 不显示图标
  success: 'weui-icon-success-no-circle', // 显示成功图标
  loading: 'weui-loading' // 显示加载图标
};
let toastDom;
// 定义弹出组件的函数 接收2个参数, 要显示的文本 和 显示时间
function showToast(object = {}) {
  const { title, duration = 3000, mask = false, icon = 'none' } = object;
  if (!toastDom) {
    toastDom = new ToastConstructor({
      el: document.createElement('div'),
      data() {
        return {
          title,
          icon: iconMap[icon],
          mask,
          show: true,
          showFade: true
        };
      }
    });
    document.body.appendChild(toastDom.$el);
  } else {
    toastDom = Object.assign(toastDom, object, {
      show: true,
      showFade: true,
      icon: iconMap[icon]
    });
  }

  // 提前 1s 执行淡出动画
  setTimeout(() => {
    toastDom.showFade = false;
  }, duration - 1000);
  // 过了 duration 时间后隐藏整个组件
  setTimeout(() => {
    toastDom.show = false;
  }, duration);
}

// 注册为全局组件的函数
function toastRegistry() {
  // 将组件注册到 vue 的 原型链里去,
  // 这样就可以在所有 vue 的实例里面使用 this.showToast()
  vue.prototype.showToast = showToast;
}

export default toastRegistry;
